// extracted by mini-css-extract-plugin
export default {"favoritesViewWrapper":"_1m0ZzfdXM3AJXHarKT9X81","emptyMessage":"_6JPDDWwEx0EYAbxCDPjUw"};